// extracted by mini-css-extract-plugin
export default {"wrapper":"Toggle_wrapper__h7n5g","active":"Toggle_active__73v4L","circle":"Toggle_circle__3nfDw"};